export const NAME = "voting";
